import { useLocation } from "react-router-dom";
import { t } from "ttag";
import { useStoreState } from "../../models/RootStore";

export const CONTROL_PPD_PATH_PREFIX = "/control-";

export const isControlBasedPPDRoute = (pathname: string) =>
  pathname.startsWith(CONTROL_PPD_PATH_PREFIX);

export const useControlBasedPPD = () => {
  const { pathname } = useLocation();
  return isControlBasedPPDRoute(pathname);
};

// When true for the customer, control-based PPD replaces service-based PPD entirely for all users,
// overriding the legacy impersonation-gated controlBasedPowerUsage behavior.
export const useIsControlBasedPpdEnabled = () => {
  const customerId = useStoreState((s: any) => s.selections.selections.customerId);
  return !!useStoreState((s: any) => s.customers.allCustomers[customerId || ""]?.isControlBasedPpdEnabled);
};

export const usePPDTitle = () => {
  const isControlBasedPPD = useControlBasedPPD();
  const isControlBasedPpdEnabled = useIsControlBasedPpdEnabled();

  if (isControlBasedPpdEnabled) {
    return t`Power Distribution`;
  }

  return isControlBasedPPD ? t`Control Power Distribution` : t`Power Distribution`;
};
